import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import * as fileSaver from 'file-saver';
import { appConstants } from '../helpers/constants';
import { StandardApiRequest, Carrier, Account, UserInfo, CostByMonth } from '../helpers/interfaces';
import { ApiService } from '../services/api.service.service';
import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-cost-pound-chart',
  templateUrl: './cost-pound-chart.component.html',
  styleUrls: ['./cost-pound-chart.component.css']
})
export class CostPoundChartComponent implements OnInit {

  constructor(private apiService: ApiService,  private notification: MatSnackBar, private router: Router, private sessionService: SessionService, private userService: UserService) { }

  displayedColumns: string[] = ['month', 'year', 'net-charge'];
  dataTable: MatTableDataSource<CostByMonth> = new MatTableDataSource();

  defaultScale = appConstants.fun.getChartScale('Month', 'Amount in Dollars');
  costPerPoundScale = appConstants.fun.getChartScale('Month', 'Amount in Dollars/lb.')
  totalWeightScale = appConstants.fun.getChartScale('Month', 'Weight in Pounds')

  userInfo!: UserInfo;
  dateToday: Date = new Date();
  form: StandardApiRequest = {
    StartDate: new Date(this.dateToday.getFullYear(), 1, 1),
    EndDate: new Date(this.dateToday),
    CarrierId: 0,
    AccountId: 0,
    ClientId: 0,
    IsPageLoad: false
  }

  Carriers: Carrier[] = [{ CarrierId: 0, CarrierName: "All" }]
  Accounts: Account[] = [{ AccountId: 0, AccountNumber: "All" }]
  
  costPoundLoading: boolean = true;


  // [COST PER POUND BY MONTH]
  public costPerPoundChartOptions: any = {
    responsive: true,
    scales: this.costPerPoundScale,
    tooltips: {
      enabled: true,
      mode: 'single',
      callbacks: {
        label: function (tooltipItems: { yLabel: string; }, data: any) {
          return ' $' + tooltipItems.yLabel;
        }
      }
    }
  };
  costPerPoundChartLabels: string[] = [];
  costPerPoundChartType: any = appConstants.CHARTS.TYPES.VERTICAL_BAR;
  costPerPoundChartLegend: boolean = false;
  costPerPoundChartData: any[] = [{ data: null }];
  public costPerPoundChartColors: Array<any> = [{}];

  ngOnInit(): void {
    this.userInfo = this.userService.userInfo;
    this.sessionService.trendsForm.ClientId = this.userInfo.ClientId;
    this.form = this.sessionService.trendsForm;

    this.apiService.makeStandardApiCall('user/GetCarriersByClient', this.form).subscribe(
      (data: any) => {
        if (data.StatusCode != 401) {
          const carriers: Carrier[] = JSON.parse(data.Value);
          this.Carriers = [];
          this.Carriers.push({ CarrierName: 'All', CarrierId: 0 });
          carriers.forEach(element => {
            this.Carriers.push(element);
          });
        }
      }
    );
    this.updateDashboardComponents();
    this.updateAccountsList();
  }

  updateAccountsList(): void {
    this.apiService.makeStandardApiCall('user/GetAccountsByClientCarrier', this.form).subscribe(
      (data: any) => {
        if (data.StatusCode != 401) {
          const accounts: Account[] = JSON.parse(data.Value);
          this.Accounts = [];
          this.Accounts.push({ AccountNumber: 'All', AccountId: 0 });
          accounts.forEach(element => {
            this.Accounts.push({ AccountNumber: element.AccountNumber.trim().toUpperCase(), AccountId: element.AccountId });
          });
        }
      }
    );
  }

  updateDashboardComponents(): void {
    this.sessionService.trendsForm = this.form;
    
    this.costPoundLoading = true;
    this.apiService.makeStandardApiCall('values/GetCostPerPoundByMonth', this.form).subscribe(
      (data: any) => {
        const chartData = appConstants.fun.parseChartDataFromApi(JSON.parse(data.Value), 'Cost');
        this.dataTable = new MatTableDataSource<CostByMonth>(JSON.parse(data.Value));

        // Set values to chart
        this.costPerPoundChartLabels = chartData.labels;
        this.costPerPoundChartData = chartData.values;
        this.costPerPoundChartOptions.isLoading = false;
        this.costPerPoundChartOptions.tooltips.callbacks;
        this.costPerPoundChartColors = [
          {
            backgroundColor: 'rgb(102,163,255,1)',
          }
        ];
        this.costPoundLoading = false;
      }
    );
  }

  downloadSearch(): void {
    this.apiService.downloadFile('GetCostPoundDownload', this.form).subscribe((response: any) => {
      let blob: any = new Blob([response], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      fileSaver.saveAs(blob, 'CostPerPound.xlsx');
    }), (error: any) => 
      () => this.notification.open('File downloaded successfully');
  }
}
